module.exports = __webpack_public_path__ + "img/Social_Studies_6.c3b18a0e.svg";